import { uniq } from 'lodash';
import { getEarliestBeginDate, getLatestEndDate } from 'lib/components/Timeline/Timeline.helpers';
import moment from 'moment';
import { clampDate } from './turbineStatusChart.helper';

export const populateLocations = (personData, selectedDate, vesselData = []) => {
    const earliestDate = getEarliestBeginDate(selectedDate);
    const latestDate = getLatestEndDate(selectedDate);
    const locations = {};

    const addLocation = (key, type, name, beginDate, endDate) => {
        const location = {
            key,
            type,
            name: type === 'VESSEL' ? vesselData.find(({ key: vesselKey }) => vesselKey === name)?.name || name : name,
            beginDate: clampDate(moment.utc(beginDate).valueOf(), earliestDate, latestDate),
            endDate: clampDate(moment.utc(endDate).valueOf(), earliestDate, latestDate),
            exitUnknown: !endDate,
            beginEarly: moment(beginDate).isBefore(earliestDate) ? beginDate : false,
        };

        if (!locations[location.key]) {
            locations[location.key] = { [location.beginDate]: location };
        } else if (!locations[location.key][location.beginDate]) {
            locations[location.key][location.beginDate] = location;
        }
    };

    personData.forEach(
        ({
            key,
            last_known_location_key: previousName,
            last_known_location_type: previousType,
            last_known_time_entered: previousBeginDate,
            last_known_time_exited: previousEndDate,
            location_key: name,
            location_type: type,
            time_entered: beginDate,
        }) => {
            if (
                key &&
                previousName &&
                previousType &&
                moment(previousBeginDate).isValid() &&
                moment(previousBeginDate).isBefore(moment(previousEndDate)) &&
                moment(previousEndDate).isAfter(moment(earliestDate))
            ) {
                addLocation(key, previousType, previousName, previousBeginDate, previousEndDate);
            }
            if (key && type && name && moment(beginDate).isValid() && moment(beginDate).isBefore(moment(latestDate))) {
                addLocation(key, type, name, beginDate);
            }
        }
    );

    const locationArray = [];

    const personKeys = uniq(personData.map((item) => item.key));

    personKeys.forEach((key) => {
        if (locations[key]) {
            Object.values(locations[key]).forEach((item) => {
                locationArray.push(item);
            });
        } else {
            locationArray.push({ key });
        }
    });

    return locationArray;
};
